app.factory('feedbackService', ['$http', '$route', function($http, $route) {
    return {
        send : function(message) {
            return $http
            .post('api/feedback/', message)
            .then(res => {
                alert.success("Message sent!");
                $route.reload()
                return res.data;
            }, errorHandler);
        }
    }
}]);
